export const buildLevelMap = (node) => {
  const levelMap = {};

  const dfs = (n) => {
    if (!n) return;
    const lvl = n.level;

    if (!levelMap[lvl]) levelMap[lvl] = { count: 0, userIds: [] };
    levelMap[lvl].count += 1;
    levelMap[lvl].userIds.push(n.userId);

    (n.children || []).forEach(dfs);
  };

  dfs(node);
  return levelMap;
};

